"use client";
import type { Dispatch, ReactElement, RefObject, SetStateAction, } from "react";
import type { GanttDependencyLineLayout, ScrollHintState, } from "./gantt-render-selectors";
import type { GanttTooltipProps } from "./GanttTooltip";
import { GanttTooltip } from "./GanttTooltip";
import type { GanttLayout } from "./gantt-types";
import { GanttScrollFade, GanttScrollFadeSide } from "./GanttScrollFade";
import { GanttTimelineSvg } from "./GanttTimelineSvg";
export interface GanttTimelineViewportProps {
    timelineScrollRef: RefObject<HTMLDivElement | null>;
    ganttIdPrefix: string;
    layout: GanttLayout;
    hoveredTaskId: string | null;
    highlightedTaskIds: ReadonlySet<string>;
    dependencyLineLayouts: GanttDependencyLineLayout[];
    tooltipPlacementData: GanttTooltipProps["tooltip"];
    scrollHintState: ScrollHintState;
    isEntranceComplete: boolean;
    onHoveredTaskIdChange: Dispatch<SetStateAction<string | null>>;
}
export function GanttTimelineViewport({ timelineScrollRef, ganttIdPrefix, layout, hoveredTaskId, highlightedTaskIds, dependencyLineLayouts, tooltipPlacementData, scrollHintState, isEntranceComplete, onHoveredTaskIdChange, }: GanttTimelineViewportProps): ReactElement {
    return (
      <div data-el="Cmarkdowngantt/Timeline/Viewport" ref={timelineScrollRef} style={{
            position: "relative",
            flex: 1,
            overflowX: "auto",
            overflowY: "auto",
        }}>
        <div style={{
            position: "relative",
            width: layout.timelineWidth,
            height: layout.chartHeight,
        }}>
          <GanttTimelineSvg ganttIdPrefix={ganttIdPrefix} layout={layout} hoveredTaskId={hoveredTaskId} highlightedTaskIds={highlightedTaskIds} dependencyLineLayouts={dependencyLineLayouts} isEntranceComplete={isEntranceComplete} onHoveredTaskIdChange={onHoveredTaskIdChange}/>
        </div>

        <GanttTooltip tooltip={tooltipPlacementData}/>

        {scrollHintState.showLeft && (<GanttScrollFade side={GanttScrollFadeSide.Left}/>)}

        {scrollHintState.showRight && (<GanttScrollFade side={GanttScrollFadeSide.Right}/>)}
      </div>
    );
}
